import {
  QuestionCircleOutlined,
  DollarOutlined,
  CoffeeOutlined,
  ShoppingCartOutlined,
  UnorderedListOutlined,
  ShoppingOutlined,
  InsertRowAboveOutlined,
  FontColorsOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import factura from "../../menus/icons/factura.js";
import emisor from "../../menus/icons/emisor.js";

let AdminModuloFinanzas = [
  {
    key: "Finanzas",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.finanzas",
    icon: QuestionCircleOutlined,
    breadcrumb: true,
    permission:['Read:emisorFactura','Read:conceptosCobro','Create:facturacionMasiva','Read:seriesFactura'],
    submenu: [
      {
        key: "facturacion",
        path: `${APP_PREFIX_PATH}/admin/facturacion`,
        title: "sidenav.facturacion.facturacion",
        icon: factura,
        permission:['Read:emisorFactura'],
        breadcrumb: true,
        submenu: [
          {
            key: "Emisores",
            path: `${APP_PREFIX_PATH}/admin/facturacion/emisores`,
            title: "sidenav.facturacion.emisores",
            icon: emisor,
            breadcrumb: true,
            permission:['Read:emisorFactura'],
            submenu: [],
          },
          {
            key: "Series",
            path: `${APP_PREFIX_PATH}/admin/facturacion/series`,
            title: "sidenav.facturacion.series",
            icon: FontColorsOutlined,
            breadcrumb: true,
            permission:['Read:seriesFactura'],
            submenu: [],
          },
          {
            key: "Masiva",
            path: `${APP_PREFIX_PATH}/admin/facturacion/masiva`,
            title: "sidenav.facturacion.masiva",
            icon: factura,
            breadcrumb: true,
            permission:['Create:facturacionMasiva'],
            submenu: [],
          },
        ],
      },
      {
        key: "cobranza",
        path: `${APP_PREFIX_PATH}/admin/cobranza`,
        title: "sidenav.cobranza.cobranza",
        icon: DollarOutlined,
        breadcrumb: true,
        permission:['Read:conceptosCobro'],
        submenu: [
          {
            key: "Conceptos",
            path: `${APP_PREFIX_PATH}/admin/cobranza/conceptos`,
            title: "sidenav.cobranza.conceptos.conceptos",
            icon: UnorderedListOutlined,
            breadcrumb: true,
            permission:['Read:conceptosCobro'],
            submenu: [
              {
                key: "Servicios",
                path: `${APP_PREFIX_PATH}/admin/cobranza/conceptos/servicios`,
                title: "sidenav.cobranza.conceptos.servicios",
                icon: CoffeeOutlined,
                breadcrumb: true,
                permission:['Read:conceptosCobro'],
                submenu: [],
              },
              {
                key: "Productos",
                path: `${APP_PREFIX_PATH}/admin/cobranza/conceptos/productos`,
                title: "sidenav.cobranza.conceptos.productos",
                icon: ShoppingCartOutlined,
                breadcrumb: true,
                permission:['Read:conceptosCobro'],
                submenu: [],
              },
              {
                key: "Clasificacion",
                path: `${APP_PREFIX_PATH}/admin/cobranza/conceptos/clasificacion`,
                title: "sidenav.cobranza.conceptos.clasificacion",
                icon: UnorderedListOutlined,
                breadcrumb: true,
                permission:['Read:clasificacionConceptos'],
                submenu: [],
              },
            ],
          },
          {
            key: "Periodos-Cobranza",
            path: `${APP_PREFIX_PATH}/admin/cobranza/periodos`,
            title: "sidenav.cobranza.periodos",
            icon: InsertRowAboveOutlined,
            breadcrumb: true,
            permission:['Read:periodosPago'],
            submenu: [],
          },
          {
            key: "Planes de pago",
            path: `${APP_PREFIX_PATH}/admin/cobranza/planes-de-pago`,
            title: "sidenav.cobranza.planespago",
            icon: ShoppingOutlined,
            breadcrumb: true,
            permission:['Read:planesPago'],
            submenu: [],
          },
          {
            key: "Ingresos",
            path: `${APP_PREFIX_PATH}/admin/cobranza/ingresos`,
            title: "sidenav.cobranza.ingresos.ingresos",
            icon: UnorderedListOutlined,
            breadcrumb: true,
            permission:['Read:planesPago'],
            submenu: [
              {
                key: "Ingresos",
                path: `${APP_PREFIX_PATH}/admin/cobranza/ingresos`,
                title: "sidenav.cobranza.ingresos.ingresos",
                icon: CoffeeOutlined,
                breadcrumb: true,
                permission:['Read:planesPago'],
                submenu: [],
              },
              {
                key: "CuentaPorCobrar",
                path: `${APP_PREFIX_PATH}/admin/cobranza/cuentas-cobrar`,
                title: "sidenav.cobranza.ingresos.cuentasporcobrar",
                icon: ShoppingCartOutlined,
                breadcrumb: true,
                permission:['Read:planesPago'],
                submenu: [],
              },
            ],
          },
        ],
      },
    ],
  },
];

export default AdminModuloFinanzas;
